import { SideNavigationProps } from "@cloudscape-design/components/side-navigation";
import { USER_ROLES, getUserRole } from "./auth";

export const getSideNavItems = (): SideNavigationProps.Item[] => {
    const userRole = getUserRole();

    if (userRole === USER_ROLES.ADMIN) {
        return [
            {
                type: 'section',
                text: 'Manage',
                items: [
                    { type: 'link', text: 'Check-in', href: '/checkin' },
                    { type: 'link', text: 'Group Check-in', href: '/group-checkin' },
                    { type: 'link', text: 'QR Code Check-in', href: '/qr-checkin' },
                    { type: 'link', text: 'Event Status', href: '/activate' },
                ],
            },
            {
                type: 'section',
                text: 'Judgement',
                items: [
                    { type: 'link', text: 'Scores', href: '/scores' },
                ],
            },
            {
                type: 'section',
                text: 'Reports',
                items: [
                    { type: 'link', text: 'Event Information', href: '/event-information' },
                ],
            },
        ];
    }

    if (userRole === USER_ROLES.SUPER_ADMIN) {
        return [
            {
                type: 'section',
                text: 'Manage',
                items: [
                    { type: 'link', text: 'Check-in', href: '/checkin' },
                    { type: 'link', text: 'Group Check-in', href: '/group-checkin' },
                    { type: 'link', text: 'QR Code Check-in', href: '/qr-checkin' },
                    { type: 'link', text: 'Event Status', href: '/activate' },
                ],
            },
            {
                type: 'section',
                text: 'Judgement',
                items: [
                    { type: 'link', text: 'Scores', href: '/scores' },
                ],
            },
            {
                type: 'section',
                text: 'Reports',
                items: [
                    { type: 'link', text: 'Leaderboard', href: '/leaderboard' },
                    { type: 'link', text: 'Event Information', href: '/event-information' },
                    { type: 'link', text: 'Combined Leaderboard', href: '/combined-leaderboard' },
                ],
            },
        ];
    }

    return [
        {
            type: 'section',
            text: 'Manage',
            items: [
                { type: 'link', text: 'Check-in', href: '/checkin' },
                { type: 'link', text: 'Group Check-in', href: '/group-checkin' },
                { type: 'link', text: 'QR Code Check-in', href: '/qr-checkin' },
            ],
        },
    ];
}